import React from 'react';
import ReactDOM from 'react-dom';
import './i18n';
import App from './app';
import ErrorBoundary from './errorBoundary';
import { Provider } from 'react-redux';
import store from 'src/redux/store/reduxStoreIndex';
import { GlobalWebsocketProvider } from './utils/GlobalWebsocketProvider/GlobalWebsocketContext';

import '@react-page/editor/lib/index.css';

window.onerror = function (message) {
	const overlay = document.getElementById('webpack-dev-server-client-overlay');
	if (overlay) {
		if (message.includes('ResizeObserver loop completed with undelivered notifications')) {
			overlay.style.display = 'none';
			return true; // Prevent this error to be displayed
		}

		overlay.style.display = 'block';
		return false; // Allow other errors to be displayed
	}
};

const rootDiv = document.getElementById('root');

ReactDOM.render(
	<ErrorBoundary>
		<Provider store={store}>
			<GlobalWebsocketProvider>
				<App />
			</GlobalWebsocketProvider>
		</Provider>
	</ErrorBoundary>,
	rootDiv
);


// import React from 'react';
// import ReactDOM from 'react-dom';

// console.log('minimal index.js running');

// ReactDOM.render(
// 	<div style={{ padding: '20px', color: 'black' }}>Minimal render works</div>,
// 	document.getElementById('root')
// );